
<modal-window :main-width="9">
  <h2>{{ isNew ? 'Add Category' : 'Edit Category' }}</h2>
  <p>{{ isNew ? 'Create a new category to organize your templates.' : 'Update the category details.' }}</p>

  <div class="form-group">
    <label>Name</label>
    <input type="text" class="form-control" v-model="form.name" placeholder="Category name" />
  </div>
  <div class="form-group">
    <label>Icon</label>
    <div class="icon-selector-container">
      <div
        class="icon-option"
        :class="{ selected: form.icon === '' }"
        @click="form.icon = ''"
        title="No Icon"
      >
        <i class="far fa-ban text-muted"></i>
      </div>
      <div
        v-for="icon in availableIcons"
        :key="icon.class"
        class="icon-option"
        :class="{ selected: form.icon === icon.class }"
        @click="form.icon = icon.class"
        :title="icon.name"
      >
        <i :class="icon.class"></i>
      </div>
    </div>
  </div>
  <template #sidebar>
    <div class="d-flex flex-column justify-content-end h-100">
      <div class="label mb-2">
        <button class="btn btn-block btn-sm btn-info" @click="close">
          <i class="far fa-times"></i>
          Cancel
        </button>
      </div>
      <div class="label mb-2">
        <button class="btn btn-block btn-sm btn-success" @click="saveAndClose">
          <i class="far fa-save"></i>
          Save and close
        </button>
      </div>
    </div>
  </template>
</modal-window>
